module.exports = __webpack_public_path__ + "img/rubybroundtrans.7cf794d3.png";